import { makeAutoObservable } from 'mobx'
import { RootStore } from './RootStore'
import { CreditUsageClient, CreditUsage } from 'api/clients/CreditUsageClient'

export class CreditUsageStore {
  creditUsage: CreditUsage | null = null
  loading = false
  rootStore: RootStore
  initialized = false

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  setLoading = (loading: boolean) => {
    this.loading = loading
  }

  setCreditUsage = (creditUsage: CreditUsage) => {
    this.creditUsage = creditUsage
  }

  setInitialized = (initialized: boolean) => {
    this.initialized = initialized
  }

  fetch = async (workspaceId: number) => {
    if (this.initialized || this.loading) return

    await this._doFetch(workspaceId)
  }

  /**
   * Force refetch of all data, bypassing the initialization guard.
   * Use this after actions that change subscription state (e.g., upgrade, cancel).
   */
  refetch = async (workspaceId: number) => {
    if (this.loading) return

    // Reset initialized to allow refetch
    this.initialized = false
    await this._doFetch(workspaceId)
  }

  private _doFetch = async (workspaceId: number) => {
    this.loading = true

    const [creditUsageRes] = await Promise.all([CreditUsageClient.getCreditUsage(workspaceId)])

    if (creditUsageRes.type === 'success') {
      this.setCreditUsage(creditUsageRes.data.credit_usage)
    }

    this.setLoading(false)
    this.setInitialized(true)
  }
}
